import React, {Component} from 'react';

import IconBox from 'lib/struct/icon/IconBox';
import Icon from 'lib/struct/icon/Icon';

import styles from './HoverHint.less';

export default class HoverHint extends Component {
	render() {
		const {hint, children} = this.props;

		return (
			<span
				className={styles['hint__block']}
			>
				<span>{children}</span>
				<IconBox
					icon={<Icon name='info' size='10' className={styles['hint__icon']} />}
					data-title={hint}
					className={styles['hint__icon-box']}
				/>
			</span>
		);
	}
}